<template>
    <div class="user_all">
        <div style="color:red;font-size:20px;">{{ $t('title.Automatically_detect_conversion_addresses') }}</div>
        <div style="margin-top: 30px">
            <el-input type="textarea" :rows="13" style="width: 50%;" v-model="originAddress"
                      :placeholder="this.$t('title.Please_enter_user_address')"></el-input>
            <el-button style="margin-left: 30px" type="primary" @click="convertAddress()">{{ $t('title.Conversion') }}</el-button>
        </div>
        <div class="show_tr">
            <el-input type="textarea" :rows="13" style="width: 50%;" v-model="addressConverted"></el-input>
        </div>
    </div>
</template>

<script>
    export default {
        name: "addressTranslation",
        data() {
            return {
                originAddress: '',
                addressConverted: '',
            }
        }, methods: {
            convertAddress() {
                const addresses = this.originAddress.split('\n');
                let tmpValue = "";
                for (let i = 0; i < addresses.length; i++) {
                    let address = addresses[i];
                    address = address.trim();
                    if (address.startsWith("TH")) {
                        tmpValue += this.to_16_decimal(address) + "\n";
                    } else if (address.startsWith("0x")) {
                        tmpValue += this.to_32_decimal(address) + "\n";
                    }
                }
                this.addressConverted = tmpValue;
            }
        }
    }
</script>

<style scoped>
    .user_all {
        padding: 20px 30px;
    }

    .active {
        color: #409EFF;
    }

    .show_tr {
        margin-top: 30px;
    }
</style>
